import React, { memo, forwardRef } from 'react';
import { Badge as NBBadge } from 'native-base';

import type { IBadgeProps } from './Badge.types';

const Badge = ({ children, ...props }: IBadgeProps, ref: any) => (
  <NBBadge
    {...props}
    startIcon={undefined}
    endIcon={undefined}
    leftIcon={undefined}
    rightIcon={undefined}
    ref={ref}
  >
    {children}
  </NBBadge>
);

export default memo(forwardRef(Badge));
